import humps from "humps";

const displayRouteName = (currentRoute: any) => {
  if (currentRoute === "/") {
    return "Nasdaq Fund Network";
  }
  const routeName = humps
    .pascalize(currentRoute)
    .replace(/([A-Z])/g, " $1")
    .trim();
  return routeName;
};

export default displayRouteName;
